<template>
	<el-row style="overflow: hidden;">
		<!-- 核心和关键词拓展列表 -->
		<el-col :span="24" class="google-list">
			<client-module
				class="clientmodule"
				:moduletitle="item[0].name"
				v-for="(item, index) in excuselist"
				:key="index"
			>
				<el-row slot="event" class="google-list-head">
					<el-button type="primary" size="mini" @click="addPrefixed(item[0])">{{
						item[0].title
					}}</el-button>
				</el-row>
				<el-row class="row-bg contentList">
					<el-col :span="24">
						<el-col
							class="item-col"
							:span="12"
							v-for="(item1, index1) in item.slice(1, item.length)"
							:key="index1"
						>
							<el-col :span="12" style="font-size: 14px;">{{ item1.name }}</el-col>
							<el-col :span="12">
								<el-switch
									v-model="item1.status"
									active-color="#1296db"
									inactive-color="#bfbfbf"
									@change="change(item1)"
								>
								</el-switch>
								<span @click="deletItem(item1)"
									>&nbsp;&nbsp;<ig-icon
										name="shanchu"
										style="color: #1296db; vertical-align: bottom; font-size: 18px;"
										class="icon-base"
									></ig-icon
								></span>
							</el-col>
						</el-col>
					</el-col>
				</el-row>
			</client-module>
		</el-col>
		<!-- 新增拓词弹框 -->
		<dialog-form
			:dialogVisible.sync="isShowDoalog"
			:formData="formData"
			:attributes="attributes"
			@close:dialogVisible="val => (isShowDoalog = val)"
			@confirm="addWebsite"
		></dialog-form>
	</el-row>
</template>

<script>
import customer from '@/mixins/customer';
import dialogForm from '@/components/dialogForm/dialogForm';
import clientModule from '@/components/client/clientModule/clientModule.vue';
import adsApi from '@/backend/services/googleAds/googleAds.js';
import { validRequired } from '@/common/elementValid.js';

//获取新用户上线方案列表的数据
export default {
	components: {
		clientModule,
		dialogForm,
	},
	mixins: [customer],
	computed: {},
	data() {
		return {
			attributes: {},
			formData: {},
			filterParams: null,
			value: true,
			isShowDoalog: false,
			excuselist: {},
		};
	},
	methods: {
		requestData() {
			this.getTopic();
		},
		async getTopic() {
			let res = await adsApi.getTopic();
			let { prefixList, prefixSuffixList, suffixList } = res.data;
			this.excuselist = {
				prefixList: [
					{
						name: '前缀+产品词',
						addClick: 'addPrefixed',
						title: '新增前缀',
						placeholder: '输入前缀，换行添加多个',
					},
					...prefixList,
				],
				suffixProductWord: [
					{
						name: '产品词+后缀',
						addClick: 'addSuffix',
						title: '新增后缀',
						placeholder: '输入后缀，换行添加多个',
					},
					...suffixList,
				],
				prefixedSuffix: [
					{
						name: '前缀+产品词+后缀',
						addClick: 'addPrefixedSuffix',
						title: '新增前缀+后缀',
						placeholder1: '输入前缀，换行添加多个',
						placeholder2: '输入后缀，换行添加多个',
					},
					...prefixSuffixList,
				],
			};
		},
		async deleteTopic(parms) {
			let res = await adsApi.deleteTopic(parms);
			if (res) {
				this.requestData();
				this.$message({
					message: '拓词删除成功',
					type: 'success',
					duration: 1500,
				});
				this.isShowDoalog = false;
			} else {
				this.$message({
					message: '拓词删除失败',
					type: 'warning',
					duration: 1500,
				});
			}
		},
		async putTopic(promise) {
			let res = await adsApi.putTopic(promise);
			if (res) {
				this.requestData();
				this.$message({
					message: '拓词修改成功',
					type: 'success',
					duration: 1500,
				});
				this.isShowDoalog = false;
			} else {
				this.$message({
					message: '拓词修改失败',
					type: 'warning',
					duration: 1500,
				});
			}
		},
		deletItem(promis) {
			this.deleteTopic({ id: promis.id });
		},
		change(val) {
			let { id, status } = val;
			let promise = { id: id, openState: status };
			this.putTopic(promise);
		},
		async addWebsite() {
			let parms = [];

			if (this.formData.contactNameH) {
				let { contactNameQ, contactNameH } = this.formData;
				contactNameQ = contactNameQ.value.split('\n');
				contactNameH = contactNameH.value.split('\n');
				contactNameQ.map(item => {
					contactNameH.map(item1 => {
						parms.push({ name: `${item}+${item1}`, type: 3 });
					});
				});
			} else {
				let { value, type } = this.formData.contactName;
				value = value.split('\n');
				value.map(item => {
					parms.push({ name: item, type: type });
				});
			}
			let res = await adsApi.postTopic(parms);
			if (res) {
				this.requestData();
				this.$message({
					message: '拓词添加成功',
					type: 'success',
					duration: 1500,
				});
				this.isShowDoalog = false;
			} else {
				this.$message({
					message: '拓词添加失败',
					type: 'warning',
					duration: 1500,
				});
			}
		},
		cancel() {
			this.isShowDoalog = false;
		},
		setFormData(junbros) {
			this.attributes = {
				title: junbros.title,
				width: '30%',
				labelWidth: '0px',
				clickModal: false,
				pressEscape: true,
			};
			if (junbros.addClick == 'addPrefixedSuffix') {
				this.formData = {
					contactNameQ: {
						formType: 'skyTextarea',
						size: 'medium',
						class: 'skyTextareaQ',
						placeholder: junbros.placeholder1,
						value: '',
						//maxlength: 800,
						rows: 10,
						type: 3,
						rules: [validRequired('请填写前缀', 'change')],
					},
					contactNameH: {
						formType: 'skyTextarea',
						size: 'medium',
						class: 'skyTextareaH',
						placeholder: junbros.placeholder2,
						value: '',
						//maxlength: 800,
						rows: 10,
						type: 3,
						rules: [validRequired('请填写后缀', 'change')],
					},
				};
				return;
			}
			if (junbros.addClick == 'addSuffix') {
				this.formData = {
					contactName: {
						formType: 'skyTextarea',
						size: 'medium',
						class: 'skyTextareaIp',
						placeholder: junbros.placeholder,
						value: '',
						//maxlength: 800,
						rows: 10,
						type: 2,
						rules: [validRequired('请填写后缀', 'change')],
					},
				};
				return;
			}
			if (junbros.addClick == 'addPrefixed') {
				this.formData = {
					contactName: {
						formType: 'skyTextarea',
						size: 'medium',
						class: 'skyTextareaIp',
						placeholder: junbros.placeholder,
						value: '',
						//maxlength: 800,
						rows: 10,
						type: 1,
						rules: [validRequired('请填写前缀', 'change')],
					},
				};
				return;
			}
		},
		addPrefixed(junbros) {
			this.isShowDoalog = true;
			this.setFormData(junbros);
		},
	},
	mounted() {
		this.requestData();
	},
};
</script>

<style scoped lang="scss">
.clientmodule {
  background-color: #fff;
  margin-bottom: 20px;
}

.item-col {
  height: 40px;
}

.row-bg {
  padding: 10px 20px;
}

::v-deep .skyTextareaQ {
  width: 98%;
}

::v-deep .skyTextareaH {
  width: 98%;
}

::v-deep .el-form {
  display: flex;
  justify-content: space-around;
}

.icon-base {
  cursor: pointer;
}
</style>
